export default __webpack_public_path__ + "static/media/tech-icon.b4c53350.svg";